import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { NeutralChip, WarnChip } from '@components';
import { CHIP_SIZE } from '@types';

type TLocationManagedChipProps = {
	/* 'suggested' = pre-selected but removable (admins);
	   'required' = locked by the location's requirements (shippers) */
	type: 'suggested' | 'required';
}

export const LocationManagedChip = (props: TLocationManagedChipProps) => {
	const { type } = props;

	if (type === 'suggested') {
		return (
			<WarnChip
				text={'Suggested'}
				CustomIcon={LightbulbOutlinedIcon}
				size={CHIP_SIZE.SMALL}
			/>
		);
	}
	return (
		<NeutralChip
			text={'Required'}
			CustomIcon={LockOutlinedIcon}
			size={CHIP_SIZE.SMALL}
		/>
	);
}
